@if (pageView === MoneyBackGuaranteePageView.HOME) {
  <div class="tw-w-full tw-px-4 tw-mb-6">
    <div class="tw-bg-gradient-black-to-light-black tw-py-2 tw-pt-3 tw-rounded-2.5 tw-flex tw-items-center tw-justify-evenly" (click)="onHomeBannerClick()">
      <div class="tw-flex tw-justify-center tw-items-center tw-px-2">
        <p class="money-back-guarantee-gradient-text tw-text-900 tw-font-bebas tw-leading-none">100%</p>
      </div>
      <span class="tw-w-[1px] tw-h-[30px] tw-bg-[rgba(255,255,255,0.1)]"></span>
      <div class="tw-flex tw-flex-col tw-leading-none tw-items-start tw-justify-center tw-gap-0.5 tw-px-2 tw-pr-3 tw-text-white tw-font-lexend tw-font-bold">
        <p class="tw-text-nowrap tw-text-gray-75" i18n="@@moneyBack">MONEY BACK</p>
        <p class="money-back-guarantee-gradient-text tw-uppercase" i18n="@@guarantee">guarantee</p>
      </div>
      <span class="tw-w-[1px] tw-h-[30px] tw-bg-[rgba(255,255,255,0.1)]"></span>
      <div class="tw-px-3 tw-pr-4 tw-text-white tw-flex tw-justify-center tw-items-center">
        <p class="tw-text-200 tw-font-lexend tw-leading-5 tw-text-gray-75">
          <span i18n="@@upgradeYourPlanNow" class="tw-mr-1">Upgrade Your <br/> Plan Now</span>
          <span class="tw-text-[#B49265] tw-text-100 tw-inline-block -tw-mb-[1px]">
            <svg
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              class="tw-w-2.5 tw-h-2.5 text-[#c7b189]"
              >
              <path
                d="M8 4 L16 12 L8 20"
                stroke="currentColor"
                stroke-width="3.5"
                stroke-linecap="round"
                stroke-linejoin="round"
                />
            </svg>
          </span>
        </p>
      </div>
    </div>
  </div>
}
@if (pageView === MoneyBackGuaranteePageView.REGIMEN) {
  <div class="tw-w-full tw-px-[14.5px] tw-relative tw-z-[5]" (click)="onRegimenBannerClick()">
    <div class="tw-bg-gradient-black-to-light-black tw-h-14 tw-rounded-2.5 tw-flex tw-items-center tw-justify-evenly tw-gap-1.5 xsm:tw-gap-3 tw-shadow-[0px_2px_4px_rgba(0,0,0,0.1)]">
      <p class="money-back-guarantee-gradient-text tw-font-bebas tw-text-900 tw-mt-1 tw-ml-2 tw-shrink-0">100%</p>
      <span class="tw-w-0.5 tw-h-[30px] tw-bg-white tw-opacity-10 tw-shrink-0"></span>
      <div class="tw-flex tw-flex-col tw-items-start tw-gap-0.5 tw-font-lexend tw-font-bold tw-shrink-0">
        <span class="tw-text-gray-75 tw-text-400 tw-leading-[18px] tw-uppercase tw-whitespace-nowrap" i18n="@@moneyBack">MONEY BACK</span>
        <span class="money-back-guarantee-gradient-text tw-py-1 -tw-my-1 tw-text-400 tw-uppercase tw-m-auto" i18n="@@guarantee">guarantee</span>
      </div>
      <span class="tw-w-0.5 tw-h-[30px] tw-bg-white tw-opacity-10 tw-shrink-0"></span>
      <div class="tw-flex tw-items-center tw-gap-1 tw-mr-[14px]">
        <span class="tw-text-gray-75 tw-font-lexend tw-font-medium tw-text-200 tw-text-center" i18n="@@seeDetails">See Details</span>
        <cs-icon class="tw-w-1 tw-h-2 tw-text-[#C3AE88] tw-shrink-0" [iconName]="'chevron_forward'"></cs-icon>
      </div>
    </div>
  </div>
}
